import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { NitroFetchOptions } from 'nitropack';
import type {
    OrderPaymentsRequest,
    OrderPaymentsResponse,
    PaymentIntentResponse,
    PaymentIntentRequest
} from '~/types';
import type { NuxtError } from '#app';

export function usePaymentIntents() {
    const apiPaymentIntentsPath = '/v1/payment-intents';
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getOrderPaymentIntent(orderUidObj: OrderPaymentsRequest): Promise<OrderPaymentsResponse | Error> {
        const url = `${apiPaymentIntentsPath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: orderUidObj
        };

        try {
            return await $_fetch<OrderPaymentsResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    async function upsertPaymentIntent(payload: PaymentIntentRequest, secret?: Nilish<string>): Promise<PaymentIntentResponse | NuxtError> {
        const method = !!secret ? 'PATCH' : 'POST';
        const updatePath = !!secret ? `${secret}/` : '';
        const url = `${apiPaymentIntentsPath}/${updatePath}`;
        const config: NitroFetchOptions<string> = {
            method,
            body: payload
        };

        try {
            return await $_fetch<OrderPaymentsResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }


    async function toggleSavePaymentMethod(secret: string, state: boolean): Promise<OrderPaymentsResponse | Error> {
        const url = `${apiPaymentIntentsPath}/${secret}/${state ? 'set' : 'unset' }-save-payment-method/`;
        const config: NitroFetchOptions<string> = {
            method: 'PATCH'
        };

        try {
            return await $_fetch<OrderPaymentsResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getOrderPaymentIntent,
        upsertPaymentIntent,
        toggleSavePaymentMethod
    };
}
